import React, { useState } from "react";
import styled from "styled-components";

const labels = [
    "1st degree AV block (1dAVb)",
    "Right bundle branch block (RBBB)",
    "Left bundle branch block (LBBB)",
    "Sinus bradycardia (SB)",
    "Atrial fibrillation (AF)",
    "Sinus tachycardia (ST)",
    "Normal",
];

export const PredictionTable = (props: { prediction: number[] }) => {
    const fillTableRow = (label: number) => {
        const percentNum = props.prediction[label] * 100;

        let c = "white";
        if (percentNum >= 75) c = "red";
        else if (percentNum >= 40) c = "yellow";
        else if (percentNum >= 10) c = "#43DAFF";

        if (percentNum >= 100 && label === 6) c = "chartreuse";

        return (
            <tr key={label}>
                <td style={{ color: c }}>{labels[label]}:</td>
                <td style={{ color: c }}>
                    {String(
                        percentNum.toLocaleString("percent", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    ) + "%"}
                </td>
            </tr>
        );
    };

    const generateTableBody = () => {
        const labelLength = labels.length;
        let tableRows = [];
        for (let i = 0; i < labelLength; i++) {
            tableRows.push(fillTableRow(i));
        }
        return tableRows;
    };

    return (
        <PredTable className="table">
            <tbody>{generateTableBody()}</tbody>
        </PredTable>
    );
};

const PredTable = styled.table`
    background-color: black;
    color: white;
`;
